<template>
    <div>
  <div>1111</div>
        <home-header></home-header>
        <div>222</div>
    </div>
</template>

<script>
import homeheader from './components/header.vue'
export default {
  name: 'home',
  components: {
    HomeHeader: homeheader
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/home/home.vue